import React from 'react';
import './MessageBubble.css';

function MessageBubble({ message, isUser, isSystem }) {
  if (isSystem) {
    // Check if this is one of the deleted messages for the easter egg
    const isDeletedMessage = 
      message.content.includes("Conversation interrompue") || 
      message.content.includes("Restauration des données") || 
      message.content.includes("Contenu supprimé");
    
    return (
      <div className={`message-system ${isDeletedMessage ? 'deleted-message' : ''}`}>
        {message.content}
      </div>
    );
  }

  // Check if message has an attachment
  const hasAttachment = message.attachment && message.attachment.file;

  // Handle attachment download
  const handleDownload = (event) => {
    event.stopPropagation();
    // The file is in the public folder, so we can use a direct URL
    window.open(`/${message.attachment.file}`, '_blank');
  };

  return (
    <div className={`message-container ${isUser ? 'user-container' : 'other-container'}`}>
      {!isUser && (
        <div className="message-sender">{message.sender}</div>
      )}
      <div className={`message-bubble ${isUser ? 'message-user' : 'message-other'} ${message.sender === 'Rebel.AI' ? 'ai-message' : ''}`}>
        <div className="message-content" style={{ whiteSpace: 'pre-line' }}>{message.content}</div>

        {/* Display attachment if present */}
        {hasAttachment && (
          <div className="message-attachment">
            <div className="attachment-icon" onClick={handleDownload}>
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"></path>
              </svg>
              <span className="attachment-name">{message.attachment.name}</span>
            </div>
          </div>
        )}

        <div className="message-time">{message.time}</div>
      </div>
    </div>
  );
}

export default MessageBubble;
